export const architectureEs = {
  architecturePage: {
    title: "Arquitectura e Integraciones",
    subtitle: "Visión técnica de la infraestructura de Sentinel Crop, contratos inteligentes e integraciones de proveedores para presentación COPA-COGECA",
    downloadDiagrams: "Descargar Diagramas",
    providerIntegrations: "Visión General de Integraciones",
    providerIntegrationsDesc: "Flujo de datos en tiempo real desde proveedores satelitales a contratos inteligentes en Base blockchain",
    dataFlow: "Flujo de Datos de Integraciones",
    weatherData: "Datos Meteorológicos",
    climateAnalysis: "Análisis Climático",
    priceFeeds: "Feeds de Precios",
    edgeFunctions: "Edge Functions",
    dataProcessing: "Procesamiento de Datos",
    aiAnalytics: "Analítica IA",
    riskAssessment: "Evaluación de Riesgo",
    monitoring: "Monitorización",
    surveillance: "Vigilancia 24/7",
    smartContracts: "Contratos Inteligentes",
    baseNetwork: "Red Base",
    userInterface: "Interfaz de Usuario",
    reactDashboard: "Panel React",
    smartContractsFlow: "Flujo de Contratos Inteligentes en Base",
    smartContractsFlowDesc: "Arquitectura técnica detallada de contratos de seguro paramétrico e integración de oráculos",
    policyCreation: "Proceso de Creación de Póliza",
    automatedMonitoring: "Monitorización Automatizada (Cada 6 Horas)",
    queryCopernicus: "Consultar Copernicus",
    satelliteData: "Datos Satelitales",
    claimTrigger: "Proceso de Activación de Reclamación",
    ndviThreshold: "Umbral NDVI",
    chainlinkOracle: "Oráculo Chainlink",
    calculatePayout: "Calcular Pago",
    processClaim: "Procesar Reclamación",
    contractFeatures: "Características del Contrato",
    eventArchitecture: "Arquitectura de Eventos",
    noEthStorage: "Sin Almacenamiento ETH",
    transparentLogging: "Registro Transparente",
    oracleIntegration: "Integración de Oráculos",
    multiPolicySupport: "Soporte Multi-póliza",
    smartContractArch: "Arquitectura de Contratos Inteligentes",
    edgeFunctionsPipeline: "Pipeline de Edge Functions",
    deploymentNetworks: "Redes de Despliegue",
    blockchainIntegration: "Integración Blockchain",
    technicalSpecs: "Especificaciones Técnicas",
    technicalSpecsDesc: "Detalles técnicos clave para implementación e integración",
    blockchainLayer: "Capa Blockchain",
    dataSources: "Fuentes de Datos",
    infrastructure: "Infraestructura",
    performanceScalability: "Rendimiento y Escalabilidad",
    performanceScalabilityDesc: "Rendimiento de nivel empresarial para miembros de COPA-COGECA",
    performanceMetrics: "Métricas de Rendimiento",
    scalabilityFeatures: "Características de Escalabilidad"
  }
};